"use client";
import React, { useContext } from "react";
import { LoaderContext } from "@/contexts/LoaderContext";
import "./index.css";

const Loader = () => {
  const { loading } = useContext(LoaderContext);

  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;